import {
  ArgumentNode,
  DocumentNode,
  Kind,
  NameNode,
  OperationTypeNode,
  parseConstValue,
  SelectionNode,
} from 'query-api-graphql';

import {
  FormState,
  getCompletedRelatedResultsFormStates,
} from 'analysis-tool/data-frame-creation/schemas/RegistrySchemaDataFrameCreationTypes';
import {sum} from 'BenchlingUtil';

/** @package */
export function buildNameNode(name: string): NameNode {
  return {kind: Kind.NAME, value: name};
}

const ONLY_LATEST_ITEM_ARGS: Array<ArgumentNode> = [
  {kind: Kind.ARGUMENT, name: buildNameNode('first'), value: parseConstValue('1')},
  {
    kind: Kind.ARGUMENT,
    name: buildNameNode('sortArgs'),
    value: parseConstValue('{sortKey: MODIFIED_AT, sortOrder: DESCENDING}'),
  },
];

export default function buildQueryApiQueryAst(queryFormState: FormState): DocumentNode | null {
  if (queryFormState.entityListingFieldName == null) {
    return null;
  }

  const numEntitySelections = queryFormState.entityFieldSelections.selections.length;
  const numResultSelections = sum(
    queryFormState.relatedResultsFormStates.map(
      (resultFormState) => resultFormState.backlinkSelections.selections.length
    )
  );

  if (numEntitySelections + numResultSelections === 0) {
    return null;
  }

  const relatedResultsFormState = queryFormState.relatedResultsFormStates;

  return {
    kind: Kind.DOCUMENT,
    definitions: [
      {
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        selectionSet: {
          kind: Kind.SELECTION_SET,
          selections: [
            {
              kind: Kind.FIELD,
              name: buildNameNode(queryFormState.entityListingFieldName),
              arguments:
                queryFormState.entityFilterArguments.length > 0
                  ? queryFormState.entityFilterArguments
                  : undefined,
              selectionSet: {
                kind: Kind.SELECTION_SET,
                selections: [
                  ...queryFormState.entityFieldSelections.selections,
                  ...getCompletedRelatedResultsFormStates(relatedResultsFormState).map(
                    (resultFormState): SelectionNode => ({
                      kind: Kind.FIELD,
                      name: buildNameNode(resultFormState.backlinkFieldName),
                      selectionSet: resultFormState.backlinkSelections,
                      arguments: [
                        {
                          kind: Kind.ARGUMENT,
                          name: buildNameNode('joinKey'),
                          value: {kind: Kind.STRING, value: resultFormState.joinKeyFieldName},
                        },
                        ...(resultFormState.onlyIncludeLatestItem ? ONLY_LATEST_ITEM_ARGS : []),
                      ],
                    })
                  ),
                ],
              },
            },
          ],
        },
      },
    ],
  };
}
